<script>
	import { ChevronRightIcon, DownloadCloudIcon, UploadCloudIcon } from "svelte-feather-icons";
	import ArsDevices from "./arsDevices";
	import GrsDevices from "./grsDevices";
	import LinkStatsHistory from './linkStatsHistory'
	import LinkLeads from './linkLeads'
	
	import { getContext, onMount, onDestroy } from "svelte";
	import Sparklines from "./Sparklines.svelte";
	import { devModeEnabled } from "../const";
	import PrimaryLink from "./primaryLink";
	import AsyncButton from "../components/AsyncButton.svelte";
	import {doFetch} from "../api";
	import notyf from "../utils/notyf";
	import { auth, hasRole } from "../auth";

	export let link;

	const flightContext = getContext('flight')
	let flight
	let arsDevices
	let grsDevices
	let grsDevicesStore
	let linkStatsHistory
	let linkLeads
	let liveInfo
	let info	
	let primaryLink

	$: arsDevice = $arsDevices && $arsDevices[link.arsDeviceId]

	function toggleSelectedGRS(grs) {
		grsDevicesStore.update(old => {
			old[grs].selected = !old[grs].selected
			return old
		})
	}

	async function linkSwitch() {
		try {
			doFetch(`flights/${$liveInfo.id}/switch`, "POST", {linkId:link.id})
		} catch (E) {
			notyf.error(E.message)
		}
	}

	onMount(() => {
		flight = flightContext.get()
		liveInfo = flight.liveServerStateStore
		info = flight.serverStateStore
		arsDevices = flight.getHandler(ArsDevices)
		grsDevices = flight.getHandler(GrsDevices)
		grsDevicesStore = grsDevices.store
		linkStatsHistory = flight.getHandler(LinkStatsHistory)
		linkLeads = flight.getHandler(LinkLeads)
		primaryLink = flight.getHandler(PrimaryLink)
	})
	onDestroy(() => {
		flight.releaseHandler(ArsDevices)
		flight.releaseHandler(GrsDevices)
		flight.releaseHandler(LinkStatsHistory)
		flight.releaseHandler(LinkLeads)
		flight.releaseHandler(PrimaryLink)
	})
</script>

{#if primaryLink}
<div class="linkSummary radioCard">
	{#if link.state === "ENDED" && $info.state === "ACTIVE"}
		<div class="linkDown">DOWN</div>
	{/if}
	<header>
		<div>
			{#if arsDevice}
				<div>{arsDevice.name}</div>
				<div>{arsDevice.radioId}</div>
			{/if}
		</div>
		<div />
		{#if $devModeEnabled && $liveInfo && $liveInfo.state === "ACTIVE" && $primaryLink.local !== link.id && hasRole($auth, 'fo')}
		<div class='switch'><AsyncButton handler={linkSwitch}>Switch</AsyncButton></div>
		{/if}
		{#if $primaryLink.local === link.id} 
			<div class="primaryIcon" data-tooltip="GRS receiving data on this Link">
				<DownloadCloudIcon size=16 />
			</div>
		{/if}
		{#if $primaryLink.remote === link.id} 
			<div class="primaryIcon" data-tooltip="ARS receiving data on this Link">
				<UploadCloudIcon size=16 />
			</div>
		{/if}
		<!-- <div class={"status " + link.state.toLowerCase()}>{link.state}</div> -->
		{#if arsDevice}
			{#if arsDevice.type === "ARS"}
				<img src="/images/Active ARS.png" alt="Active ARS" />
			{:else if arsDevice.radioType === "LTE"}
				<img src="/images/Active LTE.png" alt="Active LTE" />
			{/if}
		{/if}
	</header>
	{#if link.state && link.state !== "CREATED" && $linkStatsHistory[link.id]?.history?.rssi?.length}
		<Sparklines {link} />
	{/if}
	{#if link.grsDeviceIds && arsDevice}
		<div class="grsInfo">
			{#if arsDevice.radioType !== "LTE" && arsDevice.radioType !== "ETHERNET"}
				<span>GRS:</span>
				{#each link.grsDeviceIds as id}
					{#if $grsDevicesStore && $grsDevicesStore[id]}
						<div
							class="grs"
							class:lead={$linkLeads[link.id] === id}
							data-tooltip={`${$grsDevicesStore[id].name} (${$grsDevicesStore[id].radioId})`}
							on:click={() => toggleSelectedGRS(id)}
						/>
					{/if}
				{/each}
			{:else}
				<span class="lte" on:click={() => toggleSelectedGRS(arsDevice.id)}>More Info <ChevronRightIcon size=12/></span>
			{/if}
		</div>
	{/if}
</div>
{/if}
<style>
	.linkSummary {
		overflow-x: visible;
		margin-top: 8px;
	}
	.linkSummary::first-child {
		margin-top: 0;
	}
	.linkSummary .status {
		font-size: 8pt;
		margin-right: 8px;
	}

	.linkDown {
		color: red;
    background: darkred;
    padding: 4px;
    text-align: center;
    margin-bottom: 4px;
	}

	/** Radios on the link info **/
	.grsInfo {
		display: flex;
		margin-right: 30px;
		margin-top: 8px;
		color: #ccc;
		align-items: center;
		width: 100%;
		position: relative;
	}

	.grsInfo span {
		margin-right: 4px;
	}

	.grsInfo .lte {
		display: flex;
		align-items: center;
		cursor: pointer;
		user-select: none;
	}

	.grsInfo .grs {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: no-repeat center/70% #ccc url("../images/grs-inactive.png");
		border: 2px solid black;
		margin-right: 4px;
		/* position: relative; */
		display: inline-block;
	}

	.grsInfo .grs.lead {
		background: no-repeat center/70% #ccc url("../images/grs-primary.png");
		border: 2px solid #5189e1;
	}

	.grsInfo .grs:last-child {
		margin-right: 0;
	}

	.primaryIcon {
		color: rgb(91, 138, 167);
		margin-right: 8px;
		position: relative;
	}

	.switch {
		margin-right:8px;
	}
</style>
